module.exports = __webpack_public_path__ + "static/media/tap_07_img.d6ec8bc5.png";